// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"57":"d5bc814a","93":"855404c3","153":"02bfdeaf","284":"2df5ffcc","303":"9559f016","447":"d60b44c2","488":"b5cdb9cc","591":"a83b0b5a","821":"9b2c5336","985":"95e73c7f"}[chunkId] + ".chunk.js";
};